import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import OnePageHeader from "../header/OnePageHeader";

const OnlyHeaderLayout = ({ title, children }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <OnePageHeader title={title} isOpen={isOpen} setOpen={setOpen} />
      <Main>{children}</Main>
    </>
  );
};

export default OnlyHeaderLayout;

const Main = styled.main`
  /* min-height: 100vh; */
  min-height: calc(100vh - 6.8rem);
  background-color: ${({ theme }) => theme.color.purple_bg};
`;
